<template>
  <div>
    <div v-if="booking != null">

      <div class="dashboard-main-content">
        <v-app>
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-12">
              <div class="form-box">
                <div class="form-content pb-2">
                  <h3 class="title mb-3">Rezervasyon</h3>
                  <div class="row">
                    <div class="col-auto">
                      <span class="bookingNumberWrapper">Reservasyon Numarası : <span class="bookingNumber">{{booking.bookingNumber}}</span></span>
                    </div>
                    <div class="col-auto">
                      <div>
                        <reservation-status :booking-status="booking.bookingStatus"></reservation-status>
                        <a :href="webUrl+'/web-api/booking/'+booking.ref+'/document/agreement?locale='+locale"
                           target="_blank">
                          <button class="theme-btn w-20" style="line-height: 25px;">
                            <i class="las la-print"></i>Rezervasyonu Yazdır
                          </button>
                        </a>
                        <a :href="webUrl+'/web-api/booking/'+booking.ref+'/document/postPaymentConfirmation?locale='+locale"
                           target="_blank">
                          <button class="theme-btn w-20" style="line-height: 25px;">
                            <i class="las la-print"></i>Ödeme Belgesi Yazdır
                          </button>
                        </a>
                        <a v-if="projectName === 'miray'" :href="webUrl+'/web-api/booking/'+booking.ref+'/document/ship-ticket?locale='+locale"
                           target="_blank">
                          <button class="theme-btn w-20" style="line-height: 25px;">
                            <i class="las la-print"></i>Gemi bileti yazdır
                          </button>
                        </a>
                      </div>
                    </div>
                    <div class="col d-flex align-items-center justify-content-end">
                        <button @click="openReservationLogs" class="theme-btn w-20" style="line-height: 25px;">
                          <i class="las la-history"></i>Rezervasyon Logları
                        </button>
                    </div>

                  </div>
                  <button v-if="booking.revisionBookingId != null && booking.revisionBookingId != 0" @click="goToVersion(booking.revisionBookingId)" class="theme-btn theme-btn-small mb-2">Güncel Halini Görüntüle</button>
                  <div v-else-if="isBookingEditable()" class="btn-box pt-3 pb-4">
                    <button v-if="!edit" class="theme-btn w-20" @click="(edit = true)">Rezervasyon Güncelle</button>
                    <button v-if="edit" class="cancel-btn w-20" @click="(edit = false)">İptal</button>
                    <button v-if="edit" class="theme-btn w-20" @click="check">Kaydet</button>
                    <button v-if="!edit" class="theme-btn w-20" @click="showCancelPopup">Rezervasyonu Iptal Et</button>
                    <button v-if="!edit" class="theme-btn w-20" @click="showNoShowPopup">NO SHOW</button>
                    <button v-if="!edit && projectName === 'selectum'" class="theme-btn w-20" @click="showComplimentaryPopup">Complimentary</button>
                    <button v-if="!edit && projectName === 'selectum'" class="theme-btn w-20" @click="downloadVisaKit">Visa Kit</button>
                  </div>
                  <div class="row container" v-if="historyList != null">
                    <div class="ml-2 mr-2 mt-2 mb-2" v-for="(historyBooking,index) in historyList">
                      <button v-if="historyBooking.id != null" @click="goToVersion(historyBooking.id)" class="theme-btn theme-btn-small mb-2">Versiyon {{historyList.length-index}}</button>
                    </div>
                  </div>
                  <booking-payment-information></booking-payment-information>
                  <div class="row justify-content-between">
                    <div class="col-lg-6">
                      <div class="card-item p-3">
                        <div class="contact-form-action">
                          <div class="input-box">
                            <label class="label-text">Tarih :</label>
                            <span v-if="booking.revisionBookingId != null" class="text">{{booking.createDate | ddMMyyyy}}</span>
                            <span v-if="booking.revisionBookingId == null" class="text">{{new Date | ddMMyyyy}}</span>
                          </div>
                          <div class="input-box">
                            <label class="label-text">Acente :</label>
                            <span class="text" v-if="agencyList != null && userListMap != null && userListMap[booking.agentId] != null">{{ agencyMap[userListMap[booking.agentId].agencyId].name }} </span>
                          </div>
                          <div class="input-box" v-if="!edit">
                            <label class="label-text">User :</label>
                            <span class="text" v-if="agencyList != null && userListMap != null && userListMap[booking.agentId] != null">{{ userListMap[booking.agentId].email }}</span>
                          </div>
<!--                          <div class="input-box" v-if="edit">-->
<!--                            <label class="label-text">User :</label>-->
<!--                            <base-select-input-->
<!--                                v-model="booking.bedOption"-->
<!--                                :option-list="userList"-->
<!--                                :rules="'required'"-->
<!--                                :textkey="['email']"-->
<!--                            />-->
<!--                          </div>-->
                          <div class="input-box" v-if="edit">
                            <label class="label-text">User :</label>
                            <v-app>
                              <v-autocomplete :filter="filterUsersByEmail"
                                              :items="userList"
                                              v-model="booking.agentId"
                                              flat hide-no-data
                                              hide-details
                                              item-value="id"
                                              placeholder="User">
                                <template slot="selection" slot-scope="{ item, selected }">
<!--                                  {{item.roomNumber}} {{item.ros ? '(ROS)' : ''}} - {{  getRoomName(item.roomId) }}-->
                                  {{item.email}} - {{agencyMap[item.agencyId].name}}
                                </template>
                                <template slot="item" slot-scope="{ item, tile }">
<!--                                  <v-list-tile-content>-->
                                    {{item.email}} - {{agencyMap[item.agencyId].name}}
<!--                                  </v-list-tile-content>-->
                                </template>
                              </v-autocomplete>
                            </v-app>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6" v-if="!edit">
                      <div class="card-item p-3">
                        <div class="contact-form-action">
                          <div class="input-box">
                            <label class="label-text">Adı :</label>
                            <span class="text">{{booking.contactName}}</span>
                          </div>
                          <div class="input-box">
                            <label class="label-text">Email :</label>
                            <span class="text">{{booking.contactEmail}}</span>
                          </div>
                          <div class="input-box">
                            <label class="label-text">Telefon : </label>
                            <span class="text">{{booking.contactPhone}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6" v-else style="max-height: 300px">
                      <div class="card-item p-3">
                        <div class="contact-form-action">
                          <div class="input-box">
                            <label class="label-text">Sefer :</label>
                            <span class="text">{{booking.sail.cruise.name}}</span>
                          </div>
                          <div class="input-box">
                            <label class="label-text">Kalkış Limanı :</label>
                            <span class="text">{{booking.sail.routes[0].port.name}}</span>
                          </div>
                          <div class="input-box">
                            <label class="label-text">Kalkış Tarihi : </label>
                            <span class="text">{{booking.sail.sailDate | ddMMyyyyHHmm }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6" style="max-height: 300px" v-if="edit">
                      <div class="card-item p-3">
                        <div class="contact-form-action">
                          <div class="input-box">
                            <label class="label-text">Yatak seçimi :</label>
                            <base-select-input
                                v-model="booking.bedOption"
                                :option-list="bedOptions"
                                :rules="'required'"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6" style="max-height: 300px" v-if="edit">
                      <div class="card-item p-3">
                        <div class="contact-form-action">
                          <div class="input-box">
                          <label class="label-text">Sefer :</label>
                              <v-autocomplete :items="sailList"
                                              v-model="booking.sail.id"
                                              flat hide-no-data
                                              :menu-props='{ nudgeTop: 110,maxHeight: 175}'
                                              hide-details
                                              item-value="id"
                                              placeholder="Kabin">
                                <template slot="selection" slot-scope="{ item, selected }">
                                  {{item.sailDate | ddMMyyyy}}
                                </template>
                                <template slot="item" slot-scope="{ item, tile }">
                                  <v-list-tile-content>
                                    {{item.sailDate | ddMMyyyy}}
                                  </v-list-tile-content>
                                </template>
                              </v-autocomplete>

                          </div>

<!--                          <div class="input-box">-->
<!--                            <label class="label-text">Sefer :</label>-->
<!--                            <div class="input-box">-->
<!--                              <div class="select-contain form-group mt-auto mb-auto" style="width: auto;">-->
<!--                                <select v-model="booking.sail.id" class="select-contain-select" type="text" placeholder="" title="Sefer Tarihi">-->
<!--                                  <option v-for="sail in sailList" :value="sail.id" v-bind:key="sail.id">{{sail.sailDate | ddMMyyyy}}</option>-->
<!--                                </select>-->
<!--                              </div>-->
<!--                            </div>-->
<!--                          </div>-->
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6 mb-10" style="max-height: 300px" v-if="edit">
                      <div class="card-item p-3">
                        <div class="contact-form-action">
                          <div class="input-box">
                            <label class="label-text">Konaklama Tipi :</label>
                            <base-select-input
                                v-model="booking.accommodationType"
                                :option-list="accommodationTypes"
                                :rules="'required'"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <passenger-information-edit v-show="!edit"></passenger-information-edit>
          <passenger-information ref="passengerInformation" v-show="edit"></passenger-information>
          <!--        <span class="bookingNumberWrapper">Reservasyon Numarası : <span class="bookingNumber">{{booking.bookingNumber}}</span></span>-->
          <a v-if="!archived && booking.revisionBookingId != null && booking.revisionBookingId != 0" :href="basePath+'/bookings/'+booking.revisionBookingId" class="theme-btn theme-btn-small mb-2">Güncel Halini Görüntüle</a>
          <a v-if="archived && booking.revisionBookingId != null && booking.revisionBookingId != 0" :href="basePath+'/bookings/archived/'+booking.revisionBookingId" class="theme-btn theme-btn-small mb-2">Güncel Halini Görüntüle</a>

          <div v-else-if="isBookingEditable()" class="btn-box pb-5">
            <button v-if="edit" class="cancel-btn w-20" @click="(edit = false)">İptal</button>
            <button v-if="edit" class="theme-btn w-20" @click="check">Kaydet</button>
          </div>
          <sail-detail-showcase :sail="booking.sail"></sail-detail-showcase>


          <payment-list></payment-list>
          <refund-list></refund-list>
          <div class="row">
            <div class="col-sm-4">
              <booking-notes
                  title="Genel Notlar"
                  type="general"
              />
            </div>
            <div class="col-sm-4">
              <booking-notes
                  title="Muhasebe Notları"
                  type="accounting"
              />
            </div>
            <div class="col-sm-4">
              <booking-notes
                  title="Sefer Notları"
                  type="sail"
              />
            </div>
          </div>
        </div>
        </v-app>
      </div>

      <check-change-popup></check-change-popup>
      <remote-payment-popup></remote-payment-popup>
      <create-refund-popup></create-refund-popup>
      <create-discount-popup/>
      <create-penalty-popup/>
      <cancel-booking-popup></cancel-booking-popup>
      <create-booking-note-popup/>
      <booking-action-history/>
      <no-show-booking-popup/>

    </div>
  </div>
</template>

<script>
import BookingSidebar from "./BookingSidebar";
import PaymentList from "../payment/PaymentList";
import SailDetailShowcase from "../sail/sailDetailShowCase";
import PassengerInformation from "./PassengerInformation";
import PassengerInformationEdit from "./PassengerInformationEdit";
import CheckChangePopup from "./CheckChangeResponsePopup";
import RefundList from "../payment/RefundList";
import ReservationStatus from "../common/ReservationStatus";
import BookingPaymentInformation from "./BookingPaymentInformation";
import RemotePaymentPopup from "./RemotePaymentPopup";
import CreateRefundPopup from "./CreateRefundPopup";
import CancelBookingPopup from "./CancelBookingPopup";
import SailBatchUpdateModal from "../sail/SailBatchUpdateModal";
import CreateDiscountPopup from "./CreateDiscountPopup";
import messagePopupManager from "../../util/messagePopupManager";
import BookingNotes from "./BookingNotes";
import CreateBookingNotePopup from "./CreateBookingNotePopup";
import BaseSelectInput from "../base/BaseSelectInput";
import CreatePenaltyPopup from "./CreatePenaltyPopup";
import BookingActionHistory from "./BookingActionHistory";
import NoShowBookingPopup from "./NoShowBookingPopup";

export default {
  name: "BookingDetail",
  components: {
    NoShowBookingPopup,
    BookingActionHistory,
    CreatePenaltyPopup,
    BaseSelectInput,
    CreateBookingNotePopup,
    BookingNotes,
    CreateDiscountPopup,
    CancelBookingPopup,
    CreateRefundPopup,
    RemotePaymentPopup,
    BookingPaymentInformation,
    ReservationStatus,
    SailDetailShowcase,
    SailBatchUpdateModal,
    RefundList, CheckChangePopup, PassengerInformationEdit, PassengerInformation, PaymentList, BookingSidebar},
  data:function (){
    return{
      bedOptions: [{name:'Birlesik', id:"merged"}, {name:'Ayrı', id:"single"}],
      accommodationTypes: [{name:'Seçilmemiş', id:"NONE"}, {name:'Herşey Dahil', id:"ALL_INCLUSIVE"}, {name:'Tam Pansiyon', id:"FULL_BOARD"}],
    }
  },
  props:{
    archived: false
  },
  computed:{
    locale: {
      get(){
        return this.$store.getters.getLocale;
      }
    },
    sailList:{
      get(){
        return this.$store.getters.getSailsLite;
      }
    },
    formValid:{
      get(){
        return this.$store.getters.getPassengerEditValidation;
      }
    },
    basePath:{
      get(){
        return this.$store.getters.getBasePath;
      }
    },
    webUrl:{
      get(){
        return this.$store.getters.getServiceUrl;
      }
    },
    edit:{
      get(){
        return this.$store.getters.getReservationEdit
      },
      set(value){
        return this.$store.commit("setReservationEdit",value)
      }
    },
    historyList:{
      get(){
        return this.$store.getters.getHistoryList;
      }
    },
    booking:{
      get(){
        return this.$store.getters.getBooking;
      }
    },
    agencyList:{
      get(){
        return this.$store.getters.getAgencyList;
      }
    },
    agencyMap:{
      get(){
        let agencyList = this.$store.getters.getAgencyList;
        if(agencyList == null){
          return null;
        }
        return agencyList.reduce(function (map, agency) {
          map[agency.id] = agency;
          return map;
        }, {});
      }
    },
    userListMap:{
      get(){
        return this.$store.getters.getUserListMap;
      }
    },
    userList:{
      get(){
        return this.$store.getters.getUserList;
      }
    },
    passengers:{
      get(){
        return this.$store.getters.getPassengers;
      }
    },
    projectName:{
      get(){
        return this.$store.getters.getProjectName;
      }
    }
  },
  methods:{
    create(){
      // this.$store.dispatch("createBooking")
    },
    update(){
      // this.$store.dispatch("updateBooking")
    },
    check(){
      this.$refs.passengerInformation.validateChilds();

      setTimeout(()=>{
        this.$nextTick(()=>{
          let children = this.$refs.passengerInformation.$children;

          let errors = [];
          for (let i = 0; i < children.length; i++) {
            let child = children[i];
            let editInputChild = child.$refs.validationInput;

            if(editInputChild !== undefined) { // Check if component has editInputChild ref
              if(editInputChild.errors.length !== 0){
                errors.push(child.$props.label + " " +editInputChild.errors[0]);
              }
              // editInputChild.validateSilent().then(result => {
              //   // editInputChild.validate().then(result => {
              //   vueComp.formValid &&= result.valid;
              // })
            }
          }

          this.$refs.passengerInformation.checkFormFieldsSync().then((isValid)=>{
            if(!isValid){
              messagePopupManager.showError("Hata", errors);
            }else{
              this.$store.commit("setReCalculate", false);
              this.$store.dispatch("checkChange").then(response => {
                $("#checkChangePopup").modal("show");
              }).catch(error => {
                messagePopupManager.showError("Hata", error.response.data.message);
              })
            }
          })
        })
      },100)
      // if(this.$refs.passengerInformation.formValid){
      //   this.$store.dispatch("checkChange").then(response => {
      //     $("#checkChangePopup").modal("show");
      //   })
      // }
    },
    goToVersion(bookingId){
      if(this.archived){
        window.open(
            this.basePath+'/bookings/archived/'+bookingId,
            '_blank' // <- This is what makes it open in a new window.
        );
      }else{
        window.open(
            this.basePath+'/bookings/'+bookingId,
            '_blank' // <- This is what makes it open in a new window.
        );
      }
    },
    filterUsersByEmail(row, searchTerm){
      let email = row.email;
      let agency = this.agencyMap[row.agencyId];
      let splitSearchTerm = searchTerm.toLowerCase().split(" ");

      let matchCount = 0;
      splitSearchTerm.forEach(searchTerm=> {
        try {
          if (email.includes(searchTerm) || (agency && agency.name.toLowerCase().includes(searchTerm))) {
            matchCount++;
          }
        }catch (e){

        }
      })
      return matchCount === splitSearchTerm.length;
    },
    isBookingEditable(){
      if((this.booking.bookingStatus === 'OK' || this.booking.bookingStatus === 'PARTIALLY_PAID' || this.booking.bookingStatus === 'COMPLIMENTARY') &&
                        this.booking.revisionBookingId === 0){
        return true;
      }else{
        return false;
      }
    },
    showCancelPopup(){
      $("#cancelBookingPopup").modal("show");
    },
    showNoShowPopup(){
      $("#noShowBookingPopup").modal("show");
    },
    showComplimentaryPopup(){
      messagePopupManager.showQuestion(()=>{
        this.$store.dispatch("postComplimentary",{bookingId:this.booking.id})
        // this.amount = 0;
      },"Are you sure you want to make the reservation complimentary?")
    },
    downloadVisaKit(){
      this.$store.dispatch("generateAndDownloadVisaKit",{bookingId:this.booking.id});
    },
    openReservationLogs(){
      this.$store.commit("setBookingActionHistoryList", null);
      this.$store.dispatch("loadBookingActionHistoryList", this.booking.historyReferenceId).then(()=>{
        $("#bookingActionHistoryModal").modal("show");
      });
    }
  },
  updated() {
    setTimeout(function (){
      $(".select-contain-select").selectpicker('refresh');
      $(".select-contain").selectpicker('refresh');
    },100)
    $(".select-contain-select").selectpicker({
      size: 5,
      noneSelectedText: 'Select One'
    });
    $(".select-contain").selectpicker({
      size: 5,
    });
  },
  mounted() {
    this.edit = false;
  },
  watch:{
    edit:{
      deep:true,
      handler:function (){
        this.$refs.passengerInformation.checkValid();
        let that=this;
        setTimeout(function (){
          $('.birthDatePassengerInformation').mask('00/00/0000');
          $('.passportExpDate').mask('00/00/0000');
          $('.passportGiveDate').mask('00/00/0000');
          $(".birthDatePassengerInformation").change(function (val){
            let dd = $(this).val().split("/")[0]
            let mm = $(this).val().split("/")[1]
            let yy = $(this).val().split("/")[2]
            // let date = new Date();
            // date.setYear(yy*1)
            // date.setMonth(mm*1);
            // date.setDate(dd*1);
            that.passengers[$(this).attr("passengerIndex")].birthDate = moment.utc(dd+"/"+mm+"/"+yy, 'DD/MM/YYYY')
          });
          $(".passportExpDate").change(function (val){
            let dd = $(this).val().split("/")[0]
            let mm = $(this).val().split("/")[1]
            let yy = $(this).val().split("/")[2]
            // let date = new Date();
            // date.setYear(yy*1)
            // date.setMonth(mm*1);
            // date.setDate(dd*1);
            that.passengers[$(this).attr("passengerIndex")].expireDate = moment.utc(dd+"/"+mm+"/"+yy, 'DD/MM/YYYY')
          });
          $(".passportGiveDate").change(function (val){
            let dd = $(this).val().split("/")[0]
            let mm = $(this).val().split("/")[1]
            let yy = $(this).val().split("/")[2]
            // let date = new Date();
            // date.setYear(yy*1)
            // date.setMonth(mm*1);
            // date.setDate(dd*1);
            that.passengers[$(this).attr("passengerIndex")].issueDate = moment.utc(dd+"/"+mm+"/"+yy, 'DD/MM/YYYY')

          });
        },100)
      }
    }
  }
}
</script>

<style scoped>

.customDisabled{
  pointer-events: none;
  opacity: 0.4;
}
</style>